const route = [
  {
    path: '/reporte-taller',
    name: 'reporte-taller',
    meta: { authRequired: true },
    component: () => import('./ReporteTaller.vue')
  },
  {
    path: '/orden-taller',
    name: 'ordenTaller',
    meta: { authRequired: true },
    component: () => import('./OrdenTaller.vue')
  },
];

module.exports = {
  route
};
